import baustein from "baustein";
import { setFeedOrder } from "web/redux/ducks/feed-filters";
import { openSidebar } from "web/redux/ducks/feed-sidebar";
import { watchState } from "web/redux/state-watcher";
import store from "web/redux/store";
import analytics from "web/script/analytics/analytics";
import template from "templates/modules/filter_button/filter_button.jinja";
import { gettext } from "web/script/modules/django-i18n";

const ACTIONS = {
    newest: "SORT_BY_NEWEST",
    price_desc: "SORT_BY_HIGH_LOW",
    price_asc: "SORT_BY_LOW_HIGH",
    recommended: "SORT_BY_RECOMMENDED",
    best_sellers: "SORT_BY_BEST_SELLERS",
};

function filterCount(state) {
    return state.feedSidebarReducer.count;
}

function filterCountTooltip(count) {
    // "{count} selected"
    return gettext("feed.filters.mobile_selected_count", {
        count: count,
    });
}

// register our component
export default baustein.register("filter-button", {
    template: template,

    defaultOptions: {
        feedSortDropdown: null,
        filterCount: null,
    },
    getInitialRenderContext() {
        let filterCountValue = this.options.filterCount || filterCount(store.getState());
        return {
            feed_sort_dropdown: this.options.feedSortDropdown,
            filter_count: filterCountValue,
            filter_count_tooltip: filterCountTooltip(filterCountValue),
        };
    },

    setupEvents(add) {
        add("click", ".filter-button__filter-input", this.onFilter);
        add("change", ".filter-button__sort-select", this._onSort);
    },

    init() {
        this.unsubscribeToStateWatcher = watchState(filterCount, (count) => {
            let context = this.getRenderContext();
            context.filter_count = count;
            context.filter_count_tooltip = filterCountTooltip(count);
            this.setRenderContext(context);
        });
    },

    onRemove() {
        this.unsubscribeToStateWatcher();
    },

    onFilter() {
        this.emit("openFilters");
        analytics.event("filter", "open");
        store.dispatch(openSidebar());
    },

    _onSort() {
        const value = this.el.querySelector("[sort-dropdown]").value;

        // add analytics
        const action = ACTIONS[value];
        analytics.event("SORT_BY", action);

        store.dispatch(setFeedOrder(value));
    },
});
